import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import destinations from "../data/destinations.json";
import { Link } from "react-router-dom";

const Home = () => {
  return (
  <div>
{/* Header Section */}
<header className="relative">
  <Carousel
    autoPlay
    infiniteLoop
    showThumbs={false}
    showStatus={false}
    className="w-full h-[500px]"
  >
    {destinations.map((destination) => (
      <div>
        <img
          src={destination.image}
          alt={`${destination.name} Unsplash`}
          className="object-cover h-[500px] w-full"
        />
      </div>
    ))}
  </Carousel>
  <div className="absolute top-0 left-0 w-full h-full flex flex-col gap-8 items-center justify-center bg-black bg-opacity-40">
    <h1 className="text-white text-5xl font-bold">
      Explore the World with Us
    </h1>
    <Link to="/destinations" className="text-2xl font-bold text-white bg-blue-500 px-6 py-2 rounded-full">
              <button>View All</button>
            </Link>
  </div>
</header>

{/* Main Section */}
<main className="p-8">
  <section className="text-center mb-12">
    <h2 className="text-4xl font-bold mb-4">Destinations</h2>
    <p className="text-lg text-gray-600">
      Discover breathtaking locations for your next adventure.
    </p>
  </section>
  <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
  {destinations.map((destination) => (
    <div
      key={destination.name}
      className="bg-white shadow-lg rounded-lg overflow-hidden"
    >
      <img
        src={destination.image}
        alt={`${destination.name} Unsplash`}
        className="w-full h-48 object-cover"
      />
      <div className="p-4">
        <h3 className="text-2xl font-bold">{destination.name}</h3>
        <p className="text-gray-600 mb-4">{destination.description}</p>
        <Link
          to={`/destinations/${destination.name.toLowerCase()}`}
          className="text-blue-500 hover:underline"
        >
          View More
        </Link>
      </div>
    </div>
  ))}
</section>
</main>

{/* Footer Section */}
<footer className="bg-gray-800 text-white p-4 text-center">
  <p>&copy; 2024 Travel Website. All rights reserved.</p>
</footer>
</div>
  );
};

export default Home;



